(function () {
  function initSlider(list) {
    if (list.dataset.trustedLogosInit) return;
    list.dataset.trustedLogosInit = 'true';

    var originals = Array.prototype.slice.call(list.children);
    if (!originals.length) return;

    var track = document.createElement('div');
    track.className = 'trusted-logos__track';

    originals.forEach(function (item) {
      track.appendChild(item);
    });

    list.appendChild(track);

    function build() {
      // Remove clones, measure one full set of logos, then clone it enough times to
      // cover the visible width plus one extra set. The track moves left by exactly one
      // set width, so the jump back to 0 is invisible and the motion is always one-way.
      Array.prototype.slice.call(track.children).forEach(function (item) {
        if (item.dataset.trustedLogosClone) track.removeChild(item);
      });

      track.style.animation = 'none';
      track.style.setProperty('--trusted-logos-shift', '0px');

      var setWidth = originals.reduce(function (sum, item) {
        return sum + item.getBoundingClientRect().width;
      }, 0);

      if (!setWidth) return;

      var copies = Math.ceil(list.clientWidth / setWidth) + 1;

      for (var i = 0; i < copies; i++) {
        originals.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.dataset.trustedLogosClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
      }

      track.style.setProperty('--trusted-logos-shift', setWidth + 'px');
      track.style.animation = '';
      track.style.animationDuration = Math.max(15, setWidth / 40) + 's';
    }

    build();

    // Logo widths are only known once images have loaded.
    var pending = 0;
    originals.forEach(function (item) {
      var img = item.querySelector('img');
      if (img && !img.complete) {
        pending++;
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      }
    });

    function done() {
      if (--pending === 0) build();
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 200);
    });
  }

  function init() {
    document.querySelectorAll('.trusted-logos__list').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
